export const getSearchAddress = ({ street, number }) => {
  return [street, number].filter(Boolean).join(' ').trim()
}

export const canConfirmDropOffPoint = ({ dropOffPoints, pickedDropOffPoint, searching }) => {
  if (searching) return false

  return dropOffPoints.some(dropOffPoint => dropOffPoint.id === pickedDropOffPoint?.id)
}
